@if (carregando()) {
    <span class="absolute inset-0 flex items-center justify-center">
        <app-icon nome="carregando" [tamanho]="tamanhoIcone()" class="animate-spin motion-reduce:animate-none" />
    </span>
}
<span [class]="classesConteudo()">
    @if (icone() && iconePosicao() === 'esquerda') {
        <app-icon [nome]="icone()!" [tamanho]="tamanhoIcone()" />
    }
    <ng-content></ng-content>
    @if (icone() && iconePosicao() === 'direita') {
        <app-icon [nome]="icone()!" [tamanho]="tamanhoIcone()" />
    }
</span>
@if (carregando()) {
    <span class="sr-only">{{ rotuloCarregando() }}</span>
}
